import { getResponseData } from "@helpers/_functions";
import BaseService from "./base.service";
import http from "../http-common";

class HolidayNameService extends BaseService {
  constructor() {
    super("holiday-name");
  }

  getByEnterprise(enterpriseId) {
    return http
      .get(`${this.path}/list-holiday/${enterpriseId}`)
      .then((response) => getResponseData(response));
  }

  upsert(data) {
    return http.post(`${this.path}/upsert`, data);
  }
}

export default new HolidayNameService();